/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BUTTON_CAPTION_PRODUCE = (
    <FormattedMessage
        id='reserve_activation_popover.button_caption_produce'
        defaultMessage='Подготовить'
    />
)

export const BUTTON_CAPTION_ACTIVATE = (
    <FormattedMessage
        id='reserve_activation_popover.button_caption_activate'
        defaultMessage='Активировать'
    />
)

export const RESERVE_DOES_NOT_EXIST = (
    <FormattedMessage
        id='reserve_activation_popover.reserve_does_not_exist'
        defaultMessage='Нет на складе'
    />
)

export const BUILDING_IS_ABSENT = (buildingName) => (
    <FormattedMessage
        id='reserve_activation_popover.building_is_absent'
        defaultMessage='Для подготовки необходимо строение {buildingName}'
        values={{
            buildingName,
        }}
    />
)

export const READY_FOR_ACTIVATION = (
    <FormattedMessage
        id='reserve_activation_popover.ready_for_activation'
        defaultMessage='Готов к активации'
    />
)

export const ANOTHER_RESERVE_IS_ACTIVATED = (
    <FormattedMessage
        id='reserve_activation_popover.another_reserve_is_activated'
        defaultMessage='Активирован другой резерв этой группы'
    />
)

export const RESERVE_IS_ACTIVATED = (
    <FormattedMessage
        id='reserve_activation_popover.reserve_is_activated'
        defaultMessage='Активирован'
    />
)

export const ACTIVATABLE_IN_BATTLE_ROOM = (
    <FormattedMessage
        id='reserve_activation_popover.activatable_in_battle_room'
        defaultMessage='Активируется в боевой комнате'
    />
)
export const NEGATIVE_BALANCE = (
    <FormattedMessage
        id='reserve_activation_popover.negative_balance'
        defaultMessage='Действует штраф'
    />
)

export const RESERVIST_DOESNT_RECEIVE_BONUS = (
    <FormattedMessage
        id='reserve_activation_popover.reservist_doesnt_receive_bonus'
        defaultMessage='Резервисты не получают надбавок'
    />
)

export const ROW_HEIGHT = 118
export const VISIBLE_ROWS_COUNTER = 3



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveActivationPopover/constants.jsx